// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__nvPZo","collapse":"Columns_collapse__qvoAo"};